import { PropsWithChildren } from "react"

import { Spinner } from "components/Spinner"
import { Headline1 } from "ui-kit/components-branded/index"
import { useGetReport } from "modules/HRAccount/queries"
import { initialPeriod } from "modules/HRAccount/PeriodsDropdown/PeriodsDropdown"

export function AccessRestricted({ children }: PropsWithChildren<unknown>) {
    const { error, isInitialLoading } = useGetReport(initialPeriod)

    if (isInitialLoading) return <Spinner />
    if (error)
        return (
            <Headline1 className="has-text-centered">
                {error?.response?.status === 403 ? (
                    <>Доступ к&nbsp;статистике компании ограничен</>
                ) : (
                    "Ошибка загрузки данных"
                )}
            </Headline1>
        )

    return <>{children}</>
}
